import axios, { AxiosError, AxiosInstance } from "axios";
import useHandleError from "hooks/common/useHandleError";

interface CustomInstance extends AxiosInstance {
  get<T>(...params: Parameters<AxiosInstance['get']>): Promise<T>;
  post<T>(...params: Parameters<AxiosInstance['post']>): Promise<T>;
  put<T>(...params: Parameters<AxiosInstance['put']>): Promise<T>;
  delete<T>(...params: Parameters<AxiosInstance['delete']>): Promise<T>;
}

export const useAxios = () => {
  const { handleResponseError } = useHandleError();
  // const { accessToken } = authStore();

  const api: CustomInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    // withCredentials: true,
  });
  
  api.interceptors.request.use(
    async res => {
      const config = res;

      // if(accessToken) {
      //   config.headers['Authorization'] = `Bearer ${accessToken}`;
      // }
      config.headers['Content-Type'] = 'application/json; charset=utf-8';

      return config;
    },
    error => Promise.reject(error),
  );

  api.interceptors.response.use(
    response => {
      return response.data;
    },
    async (error: AxiosError) => {
      return (error.config?.baseURL === process.env.REACT_APP_BASE_URL) ? await handleResponseError(error) : Promise.reject(error);
    },
  );

  return { api };
}